import { CloudUploadOutlined, Edit, } from '@mui/icons-material';
import { Box, Grid, IconButton, Stack, Typography } from '@mui/material';
import React from 'react'
import { grey } from '@mui/material/colors';
import { useTranslation } from 'react-i18next';
import RowDetails from '../../components/RowDetails';
import { URLS } from '../../apis/urls';

const CardInfo = ({ item, handleEditSystemAnnouncementModal, setEditAndPreviewMessage , updateSystemAnnouncementDetails}) => {
  const { t } = useTranslation();
  return (
    <Grid
      sx={{
        borderRight: { xs: "none", md: `1px dashed ${grey[200]}` },
        display: "flex", flexDirection: "column", justifyContent: "space-between"
      }}
      size={{
        xs: 12,
        md: 4
      }}>
      <Grid container spacing={0.5} sx={{
        px: 2
      }}
      >
        <Grid size={{ xs: 12 }}>
          <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
            <Stack direction={"row"} alignItems={"center"}>
              <Typography variant="subtitle2">
                {item?.title}
              </Typography>
            </Stack>
            {item?.isHiddenEditIcon && <Stack direction={"row"} alignItems={"center"}>
              <IconButton
                onClick={() => {
                  handleEditSystemAnnouncementModal(item?.type)
                }
                }
                disabled={item?.isDisable}
              >
                <Edit />
              </IconButton>
            </Stack>}
          </Stack>
        </Grid>
        {item?.details?.map((detail) => {
          return <Grid key={detail?.title} size={{ xs: 12 }}>
            <RowDetails disabled={item?.isDisabled} title={detail?.title} value={!item?.isDisabled ? detail.value : ""} />
          </Grid>;
        })}

      </Grid>
      {item?.isPreviewDisplay && (
        <Grid size={{ xs: 12 }} sx={{
          px: 2, py: 1.5,
        }}>
          <Stack direction="row" sx={{
            justifyContent: "space-between"
          }}>
            <Typography
              variant="subtitle2"
              sx={{
                mt: { xs: 3, md: 0 },
                mb: { xs: 1.5, md: 0 },
              }}
            >
              {t("general.message")}
            </Typography>
            <Stack
              direction="row"
              spacing={0.5}
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >

              <IconButton
                aria-label="Edit"
                size="small"
                onClick={() =>
                  setEditAndPreviewMessage({
                    open: true,
                    data: item?.message,
                  })
                }
              >
                <Edit />
              </IconButton>
            </Stack>
          </Stack>

          <Box
            sx={{
              borderRadius: 1,
              height: 300,
              bgcolor: grey[100],
              p: 1.5,
              overflow: "auto",
              fontSize: 13,
              cursor: "pointer",
            }}
            dangerouslySetInnerHTML={{
              __html: item?.message
            }}
            onClick={() =>
              setEditAndPreviewMessage({
                open: true,
                data: item?.message || "",
              })
            }
          />
        </Grid>
      )}
      {item?.isImageDisplay && (
        <Grid size={{ xs: 12 }} sx={{
          px: 2, py: 1.5,
        }}>
          <Stack direction="row" sx={{
            justifyContent: "space-between"
          }}>
            <Typography
              variant="subtitle2"
              sx={{
                mt: { xs: 3, md: 0 },
                mb: { xs: 1.5, md: 0 },
              }}
            >
              {t("general.image")}
            </Typography>
            <Stack
              direction="row"
              spacing={0.5}
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >

       

              <IconButton
                  aria-label="Upload"
                  size="small"
                  component="label"
                >
                  <CloudUploadOutlined />

                  <input
                    type="file"
                    name="generalAttachment"
                    hidden
                    onChange={(event) => {
                      const selectedFile = event.target.files?.[0];
                      if (!selectedFile) return;

                      const reader = new FileReader();
                      reader.onload = () => {
                        const base64 = reader.result.split(',')[1];

                        updateSystemAnnouncementDetails([
                          {
                            id: "attachmentfilename",
                            name: selectedFile.name,
                          },
                          {
                            id: "attachmentfilecontent",
                            name: base64,
                          },
                        ]);
                      };
                      reader.readAsDataURL(selectedFile);
                    }}
                  />
                </IconButton>
            </Stack>
          </Stack>
          <Box
            sx={{
              borderRadius: 1,
              height: 300,
              bgcolor: grey[100],
              p: 1.5,
              overflow: "auto",
              backgroundImage: `url(${URLS.GET_ATTACHMENT + item?.extraData?.attachment?.id })`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
            }}
          >
          
          </Box>
        </Grid>
      )}
    </Grid>
  )
}

export default CardInfo